import { useFormik } from 'formik'
import * as Yup from 'yup';
import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { clearRoleInfo, editPermission, editPermissionAdmin, getPermissionsAdmin, getRoleInfo } from '../../actions/permissionsAction'
import EditRoleView from '../../containers/Roles/CreteRole/CreteRole'
import { useHistory } from 'react-router-dom';

const EditRole = ({ match }) => {
    const dispatch = useDispatch()
    const { listPermissionAdmin, roleInfo } = useSelector(state => state.permissionsAdmin)
    const [permisionsToAdd, setPermisionsToAdd] = useState(new Set())
    useEffect(() => {
        dispatch(getPermissionsAdmin())
        return () => {
            dispatch(clearRoleInfo())
        }
    }, [])
    useEffect(() => {
        //match.params.roleID
        dispatch(getRoleInfo(match.params.roleID))

        return () => {
          
        }
    }, [match.params.roleID])
    const validationSchema = Yup.object().shape({
        permisionsToAdd: Yup.mixed().test("size", "Requerido", (value) => {
            return value.size > 0

        }),
        name: Yup.string().required('Requerido'),
    });
    const history = useHistory()
    const formik = useFormik({
        enableReinitialize: true,

        validationSchema,
        initialValues: {
            name: roleInfo?.name || "",
            permisionsToAdd: roleInfo?.permissionsIds ? new Set(roleInfo.permissionsIds.map(permision => {
                return permision._id
            })) : new Set()
        }, onSubmit: ({ name, permisionsToAdd }) => {
            dispatch(editPermissionAdmin(
                {
                    roleId:match.params.roleID,
                    name,
                    permissionsIds: Array.from(permisionsToAdd)
                }, history
            ))
        }
    })
    return (
        <EditRoleView isEdit formik={formik} permissions={listPermissionAdmin} />
    )
}

export default EditRole